var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DashBoardProductChart"},[_c('el-card',{attrs:{"shadow":"always"}},[_c('div',{staticClass:"mb-xs"},[_vm._v("产品当前库存")]),_c('div',[_c('div',{ref:"chartBlock",staticStyle:{"height":"400px"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }